import React, { Fragment } from "react";
import PropTypes from "prop-types";

import MobileProjectPage from "components/Project/MobileProjectPage";
import "./MobileProject.css";
import placeholder_project from "images/core/placeholders/placeholder_project.png";

import { SET_PROJECT_BG_IMG } from "config";

const propTypes = {
  project: PropTypes.object.isRequired,
  projectId: PropTypes.number,
  projectImage: PropTypes.string,
  buttons: PropTypes.array,
  topics: PropTypes.array.isRequired,
  user: PropTypes.object,
  team: PropTypes.object,
  categoryId: PropTypes.string,
  notifications: PropTypes.number.isRequired,
  inboxUnread: PropTypes.number.isRequired,
  more: PropTypes.bool,
  randomNumber: PropTypes.number.isRequired,
  flavorTextArr: PropTypes.array.isRequired,
  showcaseProject: PropTypes.object,
  addAnchors: PropTypes.func,
  handleMore: PropTypes.func,
  handleOpenShareGameDialog: PropTypes.func.isRequired,
  renderTopics: PropTypes.func,
  language: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleKeyPress: PropTypes.func,
  handleSearchChange: PropTypes.func
};

const defaultProps = {
  projectImage: placeholder_project
};

class GametizeMobileProjectPage extends MobileProjectPage {
  renderGametizeLogo() {
    if (!this.props.project.backgroundImage || !SET_PROJECT_BG_IMG) {
      return <div className="mobile-project-main-image" />;
    } else {
      return null;
    }
  }

  render() {
    return (
      <Fragment>
        {this.setBackgroundImage()}
        {this.renderGametizeLogo()}
        {this.renderSlider()}
      </Fragment>
    );
  }
}

GametizeMobileProjectPage.propTypes = propTypes;
GametizeMobileProjectPage.defaultProps = defaultProps;

export default GametizeMobileProjectPage;
